/**
 * Utility functions for handling contact exports
 */

import { api } from "../../../api";
import { SpecificCustomerEnum } from "../../../enums/specific-customer.enum";

/**
 * Get export actions based on customer type
 */
export const getExportActions = (customer, filterGroups = []) => {
  const exportActions = [
    {
      label: "Export all contacts",
      onClick: async () => {
        const message = (await import("antd")).message;
        message.loading("Your data is exporting... It may take some time.");

        let csvContent;
        const customerId = customer.id;
        const isInternalOrSamsungCustomer = [
          SpecificCustomerEnum.SAMSUNG,
        ].includes(customerId);

        if (isInternalOrSamsungCustomer) {
          csvContent = await api.exportSamsungAllContacts({
            customerId,
          });
        } else {
          csvContent = await api.exportAllContacts({
            customerId,
          });
        }

        // Create and download the CSV file
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `contacts-export-${new Date().toISOString().split("T")[0]}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        message.success("Export completed successfully!");
      },
    },
  ];

  // Add "Export selected contacts" option only when filters are applied
  if (filterGroups.length > 0) {
    exportActions.push({
      label: "Export selected contacts",
      onClick: async () => {
        const message = (await import("antd")).message;
        message.loading("Your data is exporting... It may take some time.");

        let csvContent;
        const customerId = customer.id;
        const isInternalOrSamsungCustomer = [
          SpecificCustomerEnum.SAMSUNG,
        ].includes(customerId);

        // Import buildUIFilters to convert filter groups to API format
        const { buildUIFilters } = await import("./filterUtils");
        const filters = buildUIFilters(filterGroups);

        if (isInternalOrSamsungCustomer) {
          csvContent = await api.exportSamsungAllContacts({
            customerId,
            filters,
          });
        } else {
          csvContent = await api.exportAllContacts({
            customerId,
            filters,
          });
        }

        // Create and download the CSV file
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `contacts-export-filtered-${new Date().toISOString().split("T")[0]}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        message.success("Export completed successfully!");
      },
    });
  }

  return exportActions;
};
